import { render, staticRenderFns } from "./CRUDTable.vue?vue&type=template&id=354319b6&scoped=true&"
import script from "./CRUDTable.vue?vue&type=script&lang=js&"
export * from "./CRUDTable.vue?vue&type=script&lang=js&"
import style0 from "./CRUDTable.vue?vue&type=style&index=0&id=354319b6&prod&scoped=true&lang=css&"
import style1 from "./CRUDTable.vue?vue&type=style&index=1&id=354319b6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354319b6",
  null
  
)

export default component.exports